import arithmetic from "./arithmetic"
import customOps from "conf/ops"
export default {
    ...arithmetic,
    ...customOps,
}
